/**
 * Subscribe 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  membership: 'Membership',
  vipMembership: 'VIP Membership',
  membershipDesc: 'After activating the membership, you can earn more rewards each day during the validity period.',
  notJoinedYet: 'You haven\' t joined VIP membership yet.',
  tips: 'Tips:',
  tip1: '1. After activating the membership, the specified number of coins for members will be credited to the account in one go. Additionally, members will receive extra daily coins each time they open the website or launch the app.',
  tip2: '2. All the coins you have obtained through membership subscription will be cleared within seven days after the membership validity period ends.',
  free: 'Free',
  buyNow: 'Buy now!',
} as const
